/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gdpr_Status_KeptInputs */

const cs_gdpr_status_kept = /** @type {(inputs: Gdpr_Status_KeptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ponecháno`)
};

const en_gdpr_status_kept = /** @type {(inputs: Gdpr_Status_KeptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kept`)
};

/**
* | output |
* | --- |
* | "Kept" |
*
* @param {Gdpr_Status_KeptInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const gdpr_status_kept = /** @type {((inputs?: Gdpr_Status_KeptInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gdpr_Status_KeptInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gdpr_status_kept(inputs)
	return cs_gdpr_status_kept(inputs)
});